export default {
  projeto_id: '',
  maquina_id: '',
  componente_id: '',
  data: '',
  tempo_trabalhado: '',
  trabalho_executado: '',
}
